import { useState } from 'react'
import Logo from 'components/common/Logo'
import { useApp, useAuth, useTheme } from 'hooks'
import { LogOut, Moon, SquareArrowOutUpRight, Sun, User } from 'lucide-react'
import moment from 'moment'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { NavLink } from 'react-router'
import QuickSuiteChatDrawer from 'ts/components/quick-suite-chat/QuickSuiteChatDrawer'
import './TopNav.scss'
import agentBillImg from '../../assets/images/agentbill.svg'

function TopNav() {
  const { user, clearUser } = useAuth()
  const { version, packagingType, lastRunTime, isQEnabled } = useApp()
  const { theme, setTheme } = useTheme()

  const [isChatOpen, setIsChatOpen] = useState(false)

  return (
    <>
      <Navbar sticky="top" className={`glass-nav py-2 ${theme === 'dark' ? 'shadow-lg' : 'shadow-sm'}`}>
        <div className="container-fluid px-5 justify-content-between">
          <Navbar.Brand>
            <NavLink to="/">
              <Logo alt="logo" height={40} />
            </NavLink>
          </Navbar.Brand>

          <Navbar.Collapse className="flex-grow-0">
            <Nav className="align-items-center">
              <Navbar.Text className="text-end ">
                <strong className="fw-semibold text-nowrap">Welcome {user?.username}</strong>

                <div className="text-sm text-nowrap">
                  {lastRunTime && `AWS spend as of ${moment.utc(lastRunTime).local().format('MM/DD/yyyy hh:mm A')}`}
                </div>
              </Navbar.Text>
              <NavDropdown
                title={
                  <div className="avatar shadow-sm">
                    <User size={20} />
                  </div>
                }
                className="user-dropdown nav-avatar-item"
              >
                <NavDropdown.Item
                  as="a"
                  href="https://docs.finopscenter.com/personas-roles-activities"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SquareArrowOutUpRight size={16} className="me-2" />
                  Documentation
                </NavDropdown.Item>

                <NavDropdown.Item onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
                  {theme === 'dark' ? (
                    <div>
                      <Sun size={16} className="me-2" />
                      Light mode
                    </div>
                  ) : (
                    <div>
                      <Moon size={16} className="me-2" />
                      Dark mode
                    </div>
                  )}
                </NavDropdown.Item>

                <NavDropdown.Item onClick={clearUser}>
                  <LogOut size={16} className="me-2" /> Log out
                </NavDropdown.Item>

                <NavDropdown.Divider />

                <NavDropdown.ItemText>
                  <div>Release v{version}</div>
                  <div>Version: {packagingType}</div>
                </NavDropdown.ItemText>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>

          {isQEnabled && (
            <>
              <div className="vr align-self-center mx-3" style={{ height: '24px' }} />
              <Nav.Link onClick={() => setIsChatOpen(true)} className="mx-2">
                <img src={agentBillImg} alt="agent bill" height={32} />
              </Nav.Link>
            </>
          )}
        </div>
      </Navbar>
      <QuickSuiteChatDrawer isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </>
  )
}
export default TopNav
